import React from "react"
import { colors, Container, Stack } from "@carrotfertility/carotene"
import { SinglePathSVG } from "../views/SVG"
import styled from "styled-components"
import { ICategory } from "../../contentful-types"
import { useContentfulConditionalGate } from "../../lib/contentful/components/ContentfulConditionGate"
import { SubCategoryLink, AdditionalTopicsLink, useReadLearnLinks, CategoryLink } from "./shared/ReadLearnLinks"

type ReadLearnCategoryProps = {
  category: ICategory
}

const CategoryIcon = styled.img`
  width: 36px;
  height: 36px;
`

export default function ReadLearnCategory({ category }: ReadLearnCategoryProps): JSX.Element {
  const { subCategories } = category.fields
  const { categoryLink } = useReadLearnLinks({ category })

  const subCategoryToConditions = React.useMemo(
    () =>
      subCategories.map((subCategory) => ({
        element: (
          <SubCategoryLink
            key={`id-${subCategory?.fields?.navTitle ?? subCategory?.fields?.title}`}
            {...{ category, subCategory }}
          />
        ),
        conditions: subCategory?.fields?.conditions
      })),
    [category, subCategories]
  )
  const filteredSubCategory = useContentfulConditionalGate(subCategoryToConditions)
  const { showAdditionalTopics, additionalTopicCount, linksToShow } = {
    showAdditionalTopics: filteredSubCategory.length > 3,
    additionalTopicCount: filteredSubCategory.length - 3,
    linksToShow: filteredSubCategory.slice(0, 3)
  }
  return (
    <Container background={"lightGrey"} borderRadius={"8px"} padding={"32px"}>
      <Stack spacing={"tiny"}>
        <CategoryIcon src={category?.fields?.icon?.fields?.file?.url} />
        <Container stack={"tiny"}>
          <CategoryLink to={categoryLink}>
            {category?.fields?.title}
            <SinglePathSVG fill={colors.base.carrotOrange} icon="rightChevron" inline={true} />
          </CategoryLink>
        </Container>
        <Stack spacing={"tiny"}>{linksToShow}</Stack>
        {showAdditionalTopics ? (
          <Container paddingLeftRight="18px">
            <AdditionalTopicsLink categoryLink={categoryLink} additionalTopicCount={additionalTopicCount} />
          </Container>
        ) : null}
      </Stack>
    </Container>
  )
}
